<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div v-html="html"></div>
</template>

<script setup lang="tsx">
import { defineProps } from 'vue';
import { useTable } from '../../../hooks/use-table';

const props = defineProps<{
  tableHeaderList: any;
  tableDataList: Array<{ [key: string]: Array<string> }>;
}>();

const className = 'task-analysis-table-3';
const attrs = `border='0' bordercolor='#C0BEC7'`;
const { createTable } = useTable(props.tableHeaderList, className, attrs);
const html = createTable(props.tableDataList);
</script>
<style lang="scss">
@import '../../../styles/custom-table.scss';
.task-analysis-table-3 {
  --header-cell-height: 50px;
  --body-cell-height: 45px;
  $gap: 8px;
  $border: 2pt solid #c0bec7;
  thead {
    tr {
      th {
        & > div {
          color: #fff;
          overflow: hidden;
          background: var(--theme-color-1);
          border-top: $border;
          border-left: $border;
        }
        &:last-child {
          & > div {
            border-right: $border;
          }
        }
      }
      &:first-child {
        th {
          &:nth-child(1) {
            div {
              border-bottom: $border;
              background: transparent;
              border-top-right-radius: 0;
            }
          }
          &:nth-child(2) {
            div {
              border-top-left-radius: 0;
            }
          }
          &:nth-child(2),
          &:nth-child(3) {
            padding-right: $gap;
            div {
              border-right: $border;
            }
          }
          & > div {
            border-top-left-radius: 12px;
            border-top-right-radius: 12px;
          }
        }
      }
    }
  }
  tbody {
    tr {
      td {
        &:nth-child(2),
        &:nth-child(3) {
          padding-right: $gap;
          & > div {
            border-right: $border;
          }
        }
        &:last-child {
          & > div {
            border-right: $border;
          }
        }
        &:nth-child(1) {
          & > div {
            border-right: none;
          }
        }
        & > div {
          border-bottom: $border;
          border-left: $border;
        }
      }
    }
  }
}
</style>
